import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

const SortableWork = ({ work, currentUser, displayPrice }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: work.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  const completedClass = work.completed ? 'bg-success bg-opacity-10' : ''

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={`sortable-item ${completedClass}`}
      data-id={work.id}
    >
      <td
        {...attributes}
        {...listeners}
        className="sortable-handle"
        style={{ cursor: 'move' }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="3" y1="6" x2="21" y2="6" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <line x1="3" y1="18" x2="21" y2="18" />
        </svg>
      </td>
      <td>
        <div className="fw-semibold">{work.work_name || 'Работа'}</div>
        {work.work_unit && (
          <span className="text-muted small d-block">
            Ед. изм.: {work.work_unit}
          </span>
        )}
      </td>
      <td className="text-end">{work.quantity}</td>
      <td className="text-end">
        {displayPrice(work.total_price, work.total_price_for_foreman)}
      </td>
    </tr>
  )
}

export default SortableWork
